import { SET_PORTAL_SELECTED_BRANCH } from '../actions/types';

const initialState = {
  selectedBranchId: null,
};

export default function PortalFiltersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PORTAL_SELECTED_BRANCH:
      return {
        ...state,
        selectedBranchId: action.payload?.selectedBranchId ?? null,
      };
    default:
      return state;
  }
}

